import initComponents from '../../functions/init-components';
import ArticleDescriptionHeight from './components/article-description-height';
import BannerHeight from './components/banner-height';
import ChooseImageFormat from './components/choose-image-format';
import Collections from './components/collections';
import GetNoIndexImages from './components/get-noindex-images';
import InfiniteScroll from './components/infinite-scroll';
import LazyloadImages from './components/lazyload-images';
import LogoGenerator from './components/logo-generator';
import NavLinksText from './components/nav-links-text';
import PostFeedback from './components/post-feedback';
import Rating from './components/rating';
import ScrollPanel from '../../base/scroll-panel';
import ShowRelatedContent from './components/show-related-content';
import {onScroll, OpenClientSaleModal} from './components/open-sale-modal';
import AjaxSlider from '../../base/ajax-slider';

initComponents({
    ArticleDescriptionHeight,
    BannerHeight,
    ChooseImageFormat,
    Collections,
    GetNoIndexImages,
    InfiniteScroll,
    LazyloadImages,
    LogoGenerator,
    NavLinksText,
    PostFeedback,
    Rating,
    ScrollPanel,
    onScroll,
    ShowRelatedContent,
    OpenClientSaleModal,
    AjaxSlider
});

eventDelegate.addEvent('click', 'a[data-key]', (e, elem) => {
    e.preventDefault();

    const key = elem.getAttribute('data-key');
    const toggleElements = document.querySelectorAll(`[data-key="${key}"]`);
    toggleElements.forEach($el => {
        $el.classList.toggle('hidden');
    });
});

eventDelegate.addEvent('click', 'span.show-content', function () {
    const $post = this.closest('[data-id]');
    if ($post) {
        $post.querySelector('.post-short')?.classList.remove('post-short');
        this.classList.add('d-none');
    }
});
